/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ConflictResponse } from '../model/conflictResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetImportErrorMessagesResponse } from '../model/getImportErrorMessagesResponse';
import type { GetImportExportHistoriesListParams } from '../model/getImportExportHistoriesListParams';
import type { GetImportExportHistoriesResponse } from '../model/getImportExportHistoriesResponse';
import type { GetImportHistoryErrorsCsvDownloadsParams } from '../model/getImportHistoryErrorsCsvDownloadsParams';
import type { ImportExportHistorySourcesResponse } from '../model/importExportHistorySourcesResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get import/export histories
 */
export const useGetImportExportHistoriesListHook = () => {
  const getImportExportHistoriesList =
    useCustomClient<GetImportExportHistoriesResponse>();

  return (
    params?: GetImportExportHistoriesListParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getImportExportHistoriesList(
      { url: `/api/js/import_export_histories`, method: 'GET', params, signal },
      options
    );
  };
};

export const getGetImportExportHistoriesListQueryKey = (
  params?: GetImportExportHistoriesListParams
) => {
  return [
    `/api/js/import_export_histories`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetImportExportHistoriesListQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetImportExportHistoriesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportExportHistoriesListQueryKey(params);

  const getImportExportHistoriesList = useGetImportExportHistoriesListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>>
  > = ({ signal }) =>
    getImportExportHistoriesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportExportHistoriesListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>>
>;
export type GetImportExportHistoriesListQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get import/export histories
 */
export const useGetImportExportHistoriesList = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetImportExportHistoriesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetImportExportHistoriesListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetImportExportHistoriesListSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetImportExportHistoriesListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportExportHistoriesListQueryKey(params);

  const getImportExportHistoriesList = useGetImportExportHistoriesListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>>
  > = ({ signal }) =>
    getImportExportHistoriesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportExportHistoriesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>>
>;
export type GetImportExportHistoriesListSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get import/export histories
 */
export const useGetImportExportHistoriesListSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetImportExportHistoriesListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetImportExportHistoriesListHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetImportExportHistoriesListSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns a list of source types for import/export histories.

 * @summary Get import/export history source options
 */
export const useGetImportExportHistorySourcesHook = () => {
  const getImportExportHistorySources =
    useCustomClient<ImportExportHistorySourcesResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getImportExportHistorySources(
      { url: `/api/js/import_export_histories/sources`, method: 'GET', signal },
      options
    );
  };
};

export const getGetImportExportHistorySourcesQueryKey = () => {
  return [`/api/js/import_export_histories/sources`] as const;
};

export const useGetImportExportHistorySourcesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportExportHistorySourcesQueryKey();

  const getImportExportHistorySources = useGetImportExportHistorySourcesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>>
  > = ({ signal }) => getImportExportHistorySources(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportExportHistorySourcesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>>
>;
export type GetImportExportHistorySourcesQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get import/export history source options
 */
export const useGetImportExportHistorySources = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetImportExportHistorySourcesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetImportExportHistorySourcesSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportExportHistorySourcesQueryKey();

  const getImportExportHistorySources = useGetImportExportHistorySourcesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>>
  > = ({ signal }) => getImportExportHistorySources(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportExportHistorySourcesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>>
>;
export type GetImportExportHistorySourcesSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get import/export history source options
 */
export const useGetImportExportHistorySourcesSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetImportExportHistorySourcesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetImportExportHistorySourcesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get import errors in import export history page
 */
export const useGetImportHistoryErrorsHook = () => {
  const getImportHistoryErrors =
    useCustomClient<GetImportErrorMessagesResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getImportHistoryErrors(
      {
        url: `/api/js/import_export_histories/${id}/errors`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetImportHistoryErrorsQueryKey = (id: string) => {
  return [`/api/js/import_export_histories/${id}/errors`] as const;
};

export const useGetImportHistoryErrorsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportHistoryErrorsQueryKey(id);

  const getImportHistoryErrors = useGetImportHistoryErrorsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>
  > = ({ signal }) => getImportHistoryErrors(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportHistoryErrorsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>
>;
export type GetImportHistoryErrorsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get import errors in import export history page
 */
export const useGetImportHistoryErrors = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetImportHistoryErrorsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetImportHistoryErrorsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportHistoryErrorsQueryKey(id);

  const getImportHistoryErrors = useGetImportHistoryErrorsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>
  > = ({ signal }) => getImportHistoryErrors(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportHistoryErrorsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>
>;
export type GetImportHistoryErrorsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get import errors in import export history page
 */
export const useGetImportHistoryErrorsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetImportHistoryErrorsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetImportHistoryErrorsSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Download import errors file in import export history page
 */
export const useGetImportHistoryErrorsCsvDownloadsHook = () => {
  const getImportHistoryErrorsCsvDownloads = useCustomClient<Blob>();

  return (
    id: string,
    params?: GetImportHistoryErrorsCsvDownloadsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getImportHistoryErrorsCsvDownloads(
      {
        url: `/api/js/import_export_histories/${id}/errors/csv_downloads`,
        method: 'GET',
        params,
        responseType: 'blob',
      },
      options
    );
  };
};

export const useGetImportHistoryErrorsCsvDownloadsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetImportHistoryErrorsCsvDownloadsHook>>
    >,
    TError,
    { id: string; params?: GetImportHistoryErrorsCsvDownloadsParams },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useGetImportHistoryErrorsCsvDownloadsHook>>
  >,
  TError,
  { id: string; params?: GetImportHistoryErrorsCsvDownloadsParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const getImportHistoryErrorsCsvDownloads =
    useGetImportHistoryErrorsCsvDownloadsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetImportHistoryErrorsCsvDownloadsHook>>
    >,
    { id: string; params?: GetImportHistoryErrorsCsvDownloadsParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return getImportHistoryErrorsCsvDownloads(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetImportHistoryErrorsCsvDownloadsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetImportHistoryErrorsCsvDownloadsHook>>
  >
>;

export type GetImportHistoryErrorsCsvDownloadsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Download import errors file in import export history page
 */
export const useGetImportHistoryErrorsCsvDownloads = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetImportHistoryErrorsCsvDownloadsHook>>
    >,
    TError,
    { id: string; params?: GetImportHistoryErrorsCsvDownloadsParams },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useGetImportHistoryErrorsCsvDownloadsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Download an import/export history file
 */
export const useDownloadImportExportHistoryHook = () => {
  const downloadImportExportHistory = useCustomClient<Blob>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return downloadImportExportHistory(
      {
        url: `/api/js/import_export_histories/${id}/download`,
        method: 'GET',
        responseType: 'blob',
      },
      options
    );
  };
};

export const useDownloadImportExportHistoryMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadImportExportHistoryHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDownloadImportExportHistoryHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const downloadImportExportHistory = useDownloadImportExportHistoryHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDownloadImportExportHistoryHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return downloadImportExportHistory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadImportExportHistoryMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadImportExportHistoryHook>>>
>;

export type DownloadImportExportHistoryMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse
>;

/**
 * @summary Download an import/export history file
 */
export const useDownloadImportExportHistory = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadImportExportHistoryHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useDownloadImportExportHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Cancel a processing import/export job
 */
export const useCancelImportExportHistoryHook = () => {
  const cancelImportExportHistory = useCustomClient<void>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return cancelImportExportHistory(
      { url: `/api/js/import_export_histories/${id}/cancel`, method: 'POST' },
      options
    );
  };
};

export const useCancelImportExportHistoryMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelImportExportHistoryHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCancelImportExportHistoryHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const cancelImportExportHistory = useCancelImportExportHistoryHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCancelImportExportHistoryHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelImportExportHistory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelImportExportHistoryMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCancelImportExportHistoryHook>>>
>;

export type CancelImportExportHistoryMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse
>;

/**
 * @summary Cancel a processing import/export job
 */
export const useCancelImportExportHistory = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelImportExportHistoryHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useCancelImportExportHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};
